import React from 'react';
const Container = React.lazy(() => import('@material-ui/core/Container'));
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx'
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    moduleManagement_message: {
        borderLeft: '3px solid #E8B32E',
        padding: '5px 0 5px 15px',
        marginBottom: theme.spacing(3),

        '& a': {
            textDecoration: 'none',
            color: '#3f51b5',

            '&:hover': {
                textDecoration: 'underline',
            },
        }
    },
}));

export const StyledMessageComponent = ({
    children, message = ''
}) => {
    const classes = useStyles();

    return (<Container
        maxWidth={false}
        className={classes.moduleManagement_message}
    >
        {!!children
            ? children
            : (<Typography
                variant={'body2'}
                align={'justify'}
            >
                {message}
            </Typography>)
        }
    </Container>)
}

